<template>
    <modal-template>
        <div slot="header">
            {{ trans('reporting.certdownload.title') }}
        </div>

        <div slot="body">
            <section class="form-section">
                <div class="form-row">
                    <div class="form-row__col">
                        <alert type="info">
                            {{ trans('reporting.certdownload.info') }}
                        </alert>
                    </div>
                </div>
                <div class="form-row" v-if="loading">
                    <div class="form-row__col">
                        <div class="h:text-center h:margin-top-12">
                            <div
                                class="donut-spinner donut-spinner--large"
                            ></div>
                        </div>
                    </div>
                </div>
                <div class="form-row" v-if="!loading">
                    <div class="form-row__col form-row__col--one-half">
                        <form-input
                            v-model="email"
                            name="email"
                            :required="true"
                        >
                            {{ trans('reporting.certdownload.label.email') }}
                        </form-input>
                    </div>
                </div>
                <div class="form-row" v-if="!loading">
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">{{
                            trans('reporting.certdownload.label.startdate')
                        }}</label>
                        <input
                            type="date"
                            name="start_date"
                            class="input"
                            v-model="startDate"
                        />
                    </div>
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">{{
                            trans('reporting.certdownload.label.enddate')
                        }}</label>
                        <input
                            type="date"
                            name="end_date"
                            class="input"
                            v-model="endDate"
                        />
                    </div>
                </div>
                <div class="form-row" v-if="!loading">
                    <div class="form-row__col">
                        <alert
                            v-if="
                                this.filteredCertificates.length > 0 &&
                                    this.filteredCertificates.length >=
                                        this.maxAllowedCertificates
                            "
                            type="warning"
                        >
                            {{
                                trans('reporting.certdownload.limit_date', {
                                    number: filteredCertificates.length,
                                    limit: this.maxAllowedCertificates,
                                })
                            }}
                        </alert>
                        <alert v-else :type="summaryType">
                            {{
                                trans('reporting.certdownload.summary', {
                                    number: filteredCertificates.length,
                                })
                            }}
                        </alert>
                    </div>
                </div>
            </section>
        </div>

        <div slot="footer">
            <div class="page-control h:margin-top-4">
                <div class="page-control__element">
                    <button
                        type="button"
                        @click="$emit('close')"
                        class="btn btn--big btn--secondary h:margin-right-4"
                    >
                        {{ trans('buttons.cancel') }}
                    </button>
                    <button
                        type="button"
                        :disabled="submitdisabled"
                        @click="submit"
                        class="btn btn--big btn--primary"
                    >
                        {{ trans('buttons.ok') }}
                    </button>
                </div>
            </div>
        </div>
    </modal-template>
</template>

<script>
import { EventBus } from '../eventbus.js';
import axiosDownload from '../../util/axiosDownload';
import { simplyfyFilterDataForBackend } from './partials/simplifyFilterDataForBackend.js';
import { getDefaultFilterData } from './partials/getDefaultFilterData.js';

export default {
    props: {
        query: {
            type: String,
            default: '',
        },
        filter: {
            type: Object,
            default: getDefaultFilterData,
        },
    },
    data() {
        var oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        return {
            email: this.currentUser.email,
            startDate: new Date(oneMonthAgo).toISOString().substr(0, 10),
            endDate: new Date().toISOString().substr(0, 10),
            certresource: [],
            loading: true,
            maxAllowedCertificates: 1000,
        };
    },

    computed: {
        jsStartDate() {
            return new Date(this.startDate);
        },
        jsEndDate() {
            return new Date(this.endDate);
        },
        submitdisabled() {
            return (
                !this.filteredCertificates.length ||
                this.filteredCertificates.length > this.maxAllowedCertificates
            );
        },
        filteredCertificates() {
            return this.certresource.filter(item => {
                var temp = new Date(item.finished_at);
                return (
                    temp >= this.jsStartDate.setHours(0, 0, 0, 0) &&
                    temp <= this.jsEndDate.setHours(23, 59, 59, 999)
                );
            });
        },
        summaryType() {
            return this.filteredCertificates.length &&
                this.filteredCertificates.length < this.maxAllowedCertificates
                ? 'success'
                : 'warning';
        },
    },
    mounted() {
        // Get and format data
        axios
            .get(
                this.route(
                    'tenantapi.reporting.get_packaged_certificates_data'
                ),
                {
                    params: {
                        ...simplyfyFilterDataForBackend(this.filter),
                        query: this.query,
                    },
                }
            )
            .then(({ data }) => {
                this.certresource = data;
                this.loading = false;
            });
    },

    methods: {
        /**
         * When submit, send the seleted learning contents data back to FormFields.
         */
        submit() {
            var startDate =
                this.jsStartDate.getDate() +
                '-' +
                (this.jsStartDate.getMonth() + 1) +
                '-' +
                this.jsStartDate.getFullYear();
            var endDate =
                this.jsEndDate.getDate() +
                '-' +
                (this.jsEndDate.getMonth() + 1) +
                '-' +
                this.jsEndDate.getFullYear();
            axios({
                method: 'post',
                url: this.route('tenantapi.reporting.packaged_certificates'),
                data: {
                    courseProgressIdArray: this.filteredCertificates.map(
                        item => item.id
                    ),
                    email: this.email,
                    dateString: startDate + '_' + endDate,
                },
            })
                .then(response => {
                    this.flash(response);
                })
                .catch(error => {
                    this.flash({
                        message: this.trans('reporting.flash.error'),
                        level: 'warning',
                    });
                });
            this.$emit('close');
        },
    },
};
</script>
